import Close from '@material-ui/icons/Close';
import FileUploadOutlined from '@material-ui/icons/InsertDriveFileRounded';
import { Autocomplete, ButtonBase, TextField } from "@mui/material";
import React, { Fragment, useRef, useState } from "react";
import uploadDarkImage from "../../../../images/upload_dark.png";
import uploadImage from "../../../../images/upload.png";

const FileField = ({ textfieldProps, autoCompleteProps, multiple, files, setFiles, width }) => {
  const fileRef = useRef(null);
  const [isUpload, setIsUpload] = useState(false);

  const handleCarouselFiles = (e) => {
    setIsUpload(false);
    const selectedFiles = e.target.files;
    if (multiple) {
      setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
      setIsUpload(true);

    } else {
      setFiles(selectedFiles);
      setIsUpload(true);

    }
  };
  const clearCV = () => {
    setFiles("");
    if (fileRef.current) {
      fileRef.current.value = "";
    }

  };
  const fileUpload = () => {
    const fileInput = document.getElementById("get-file");
    fileInput.accept = "image/*,.doc,.docx,.pptx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .pdf";
    fileInput.click();
  };
  const handleCarouselInput = () => {
    fileRef.current.click();
  };
  return (
    <Fragment>
      {/* <Autocomplete
        multiple
        options={Array.from(files)}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            {...(textfieldProps ?? {})}
            disabled
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Fragment>
                  {files.length > 0 && (
                    <ButtonBase
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setFiles([]);
                      }}
                      sx={{
                        paddingRight: "0.5rem",
                      }}
                    >
                      <Close />
                    </ButtonBase>
                  )}
                  <ButtonBase>
                    <FileUploadOutlined onClick={handleCarouselInput} />
                  </ButtonBase>
                </Fragment>
              ),
            }}
            sx={{
              color: "inherit",
              "& .MuiInputBase-root , & .MuiInputBase-input": {
                paddingRight: "1rem !important",
              },
              "& .MuiInputLabel-root": {
                color: "black",
              },
              "& .Mui-disabled": {
                WebkitTextFillColor: "black",
              },
              "&::placeholder": {
                color: "rgba(0, 0, 0, 0.6) !important",
              },
            }}
          />
        )}
        value={Array.from(files)}
        onChange={(event, newValue) => {
          event.preventDefault();
          setFiles(newValue);
        }}
        open={false}
        sx={{
          caretColor: "transparent",
          cursor: "pointer",
          "& .Mui-disabled,& .MuiInputLabel-root": {
            color: "rgba(0,0,0,0.6)",
            backgroundColor: "transparent",
          },
          width: width || "100%",
        }}
        {...(autoCompleteProps ?? {})}
      />
      <input type="file" ref={fileRef} style={{ display: "none" }} onChange={handleCarouselFiles} multiple={multiple} />
     */}

      {/* <div id="dropzone" className="dropzone">
        <img
          id="upload-img"
          src={isUpload ? uploadDarkImage : uploadImage}
          className="upload-image"
          alt="upload-file"
        />
        <p>Drag and drop to upload file</p>
      </div> */}
      <div
        id="dropzone"
        className="border border-2 text-center mx-auto"
        style={{
          height: "200px",
          width: "200px",
        }}
      >
        <img
          id="upload-img"
          src={uploadDarkImage}
          className="w-75"
          alt="upload-file"
        />
        <p>Drag and drop to upload file</p>
      </div>
      {files && files.length > 0 && (
        <div className='d-flex'>
          <strong>Selected Files:</strong>
          <div className="d-flex">
            {Array.from(files).map((file, index) => (
              <p className='ms-2' key={index}>{file.name}</p>
            ))}
          </div>
        </div>
      )}
      <button
        type="button"
        className="btn rounded-0 btn--primary fs-7 lh-1 my-2 mx-auto d-block"
        onClick={fileUpload}
      // disabled={loadingFilters}
      >
        Browse File
        <i className="fas fa-cloud-arrow-up text-white mb-1 ms-2" />
      </button>
      <input
        type="file"
        id="get-file"
        ref={fileRef}
        style={{ display: "none" }}
        onChange={handleCarouselFiles}
        multiple={multiple}
      />

    </Fragment>
  );
};

export default FileField;
